import { Box, Container, Grid, Stack } from "@eworkit/iris";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { fetchPublicProfileNewsList, PublicProfile } from "@/data/public-profiles";
import { useFetcher } from "@/hooks/http";
import { AboutUsSection } from "@/views/Clients/Details/components/AboutUsSection";
import { SocialSection } from "@/views/Clients/Details/components/SocialSection";

import { PublicProfileNewsWidget } from "../News/PublicProfileNewsWidget";
import { RecentJobsWidget } from "../RecentJobsWidget";
import { BenefitsSection } from "./components/BenefitsSection";

export interface IClientPageDetailsTabProps {
  publicProfile: PublicProfile;
  isPublic?: boolean;
}

export const ClientPageDetailsTab: FC<IClientPageDetailsTabProps> = ({ publicProfile, isPublic = false }) => {
  const { t } = useTranslation("public");

  const newsFetcher = useFetcher(
    async () =>
      await fetchPublicProfileNewsList({
        page: 0,
        size: 2,
        publicProfileId: publicProfile.id,
        sortConfig: [
          {
            sortBy: "publicationDate",
            order: "DESC",
          },
        ],
        filtersConfig: {
          status: "ACTIVE",
        },
      }),
    [publicProfile.id],
  );

  return (
    <Container>
      <Box px={[null, null, null, "sm"]}>
        <Grid columns={["1fr", null, null, "repeat(12, 1fr)"]}>
          <Box gridColumnStart={1} gridColumnEnd={[2, null, null, 9]} gridRowStart={1} gridRowEnd={2}>
            <Stack gap="sm">
              <AboutUsSection company={publicProfile} />
              {publicProfile.benefits.length > 0 && <BenefitsSection benefits={publicProfile.benefits} />}
              {newsFetcher.payload && newsFetcher.payload.content.length > 0 && (
                <PublicProfileNewsWidget
                  publicProfile={publicProfile}
                  header={t("CLIENT_PAGE.NEWS_TITLE")}
                  isPublic={isPublic}
                  news={newsFetcher.payload.content}
                  newsCount={newsFetcher.payload.totalElements}
                />
              )}
            </Stack>
          </Box>

          <Box
            gridColumnStart={[1, null, null, 9]}
            gridColumnEnd={[1, null, null, 13]}
            gridRowStart={[2, null, null, 1]}
            gridRowEnd={[3, null, null, 2]}>
            <Stack gap="sm">
              <SocialSection publicProfile={publicProfile} />
              <RecentJobsWidget publicProfileIds={[publicProfile.id]} slug={publicProfile.slug} isPublic={isPublic} />
            </Stack>
          </Box>
        </Grid>
      </Box>
    </Container>
  );
};
